import { useState } from 'react'

import TotallyMoneySymbolOnly from '@ilg-totallymoney/ui/brandassets/logos/TotallyMoneySymbolOnly'
import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton/LinkButton'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'

import AppAdoptionHeaderBackground from '@images/bg-squiggle.png'

const AppAdoptionHeader = ({ customerId }: { customerId?: string }) => {
    const [showAppAdoptionHeader, setShowAppAdoptionHeader] = useState(true)

    return showAppAdoptionHeader && customerId ? (
        <Stack
            p="space30"
            pb="space20"
            backgroundColor="productNeutral120"
            backgroundImage={`url(${AppAdoptionHeaderBackground?.src})`}
            style={{ backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
            space="space20"
        >
            <Flex justifyContent="space-between">
                <Box width="space50">
                    <TotallyMoneySymbolOnly />
                </Box>

                <Box onClick={() => setShowAppAdoptionHeader(false)}>
                    <Icon icon="close" size={20} />
                </Box>
            </Flex>

            <Box>
                <Heading variant="60">Switch to the app</Heading>

                <Text variant="100">
                    View all card offers available with our app.
                </Text>
            </Box>

            <LinkButton
                href={`https://totallymoney.app.link/rVTn5VO5dAb/?customerId=${customerId}`}
                variant="secondaryOutline"
                text="Open the app"
            />
        </Stack>
    ) : null
}

export default AppAdoptionHeader
